module.exports = __webpack_public_path__ + "img/vrbee-bg.38d16a55.jpg";